import api from '../../../services/Api';
import { IAuditoriaCorrelacaoReceitaResultado } from '../interfaces/IAuditoriaCorrelacaoReceita';

export const AuditoriaCorrelacaoReceitaService = {
  buscarResultado: async (params: { empresaId: number; periodo: string | undefined })
    : Promise<IAuditoriaCorrelacaoReceitaResultado> => {
    const response = await api.get<IAuditoriaCorrelacaoReceitaResultado>(
      'auditoria-correlacao-receita/resultado',
      { params: { empresaIds: params.empresaId, periodo: params.periodo } }
    );
    return response.data;
  },
};
